<template>
    <div @click="selectCourse" :class="{'tw:ring-2 tw:ring-blue-500': isSelected, 'tw:opacity-70 tw:cursor-not-allowed': course.available_places === 0, 'tw:cursor-pointer': course.available_places}">
        <ContentWrapper :pointer="true">
            <div class="tw:space-y-2 tw:pl-1 tw:mb-0">
                <div class="tw:text-sm tw:flex tw:gap-1">
                    <CalendarIcon class="tw:h-3 tw:w-3 tw:mt-0.5 tw:flex-none" />
                    <div>
                        <div v-for="(day, i) in course.days" :key="i">
                            {{ courseDayLabelPrefix(i) }} <span v-html="day"></span>
                        </div>
                    </div>
                </div>
                <div class="tw:text-sm tw:flex tw:items-center tw:gap-1">
                    <UserPlusIcon class="tw:h-3 tw:w-3 tw:flex-none" />
                    {{ availablePlacesText }}
                    <span class="tw:rounded-4xl tw:h-1.5 tw:w-1.5 " :class="{'tw:bg-red-600' : !course.available_places, 'tw:bg-green-600' : course.available_places}"></span>
                </div>
                <div class="tw:text-sm tw:flex tw:items-center tw:gap-1" v-if="course.instructor">
                    <UserIcon class="tw:h-3 tw:w-3 tw:flex-none" />
                    {{ course.instructor }}
                </div>
                <div class="tw:text-sm tw:flex tw:items-center tw:gap-1" v-if="course.location">
                    <MapPinIcon class="tw:h-3 tw:w-3 tw:flex-none" />
                    {{ course.location}}
                </div>
                <div class="tw:mt-4">
                    <ProductFooter>
                        <ProductPrice :price="item.price" :compareAt="item.compareAt" :deliveryFee="item.deliveryFee" />
                    </ProductFooter>
                </div>
            </div>
        </ContentWrapper>
    </div>
</template>
<script setup>
import ProductFooter from "./product/footerWrapper.vue";
import ProductPrice  from "./product/price.vue";
import ContentWrapper from "./product/contentWrapper.vue";
import { CalendarIcon, UserPlusIcon, UserIcon, MapPinIcon } from '@heroicons/vue/24/solid'
import { computed } from "vue";
import { useWebShopStore } from "./webshopState";

const webShopState = useWebShopStore();
const { item, course, classId, courseId, isSelected } = defineProps({
    item: { type: Object, required: true },
    course: { type: Object, required: true },
    classId: { type: Number, required: true },
    officeId: { type: Number, required: true },
    idx: { type: Number, required: true },
    isSelected: { type: Boolean, default: false },
});

const selectCourse = () => {
    if (!course.available_places) {
        // Can't book on full course
        return;
    }
    webShopState.selectCourse(item, course)
};

const courseDayLabelPrefix = (index) => {
    if (course.days.length === 1) {
        return ''
    }
    return `${window.TABS.$t('Dag')} ${(index+1)} - `
}
const availablePlacesText = computed(() => {
    const placesAvailable = course.available_places > 3 ? '3+' : course.available_places;
    if (course.available_places === 0) {
        return window.TABS.$t('Fullbooket');
    }
    if (placesAvailable === 1) {
        return `${placesAvailable} ${window.TABS.$t('plass')}`;
    }
    return `${placesAvailable} ${window.TABS.$t('plasser')}`;
});
</script>